module.exports = __webpack_public_path__ + "img/Group 47.23adda8c.png";